﻿import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Chip from "@mui/material/Chip";
import PeopleIcon from "@mui/icons-material/People";
import * as React from "react";

type ImpersonationLabelProps = {
    label: string;
};


const ImpersonationChip = styled(Chip)(({ theme }) => {
    return {
        color: theme.palette.primary.contrastText,
        fontSize: '12px'
    };
});

function ImpersonationLabel({ label }: ImpersonationLabelProps) {
    let theme = useTheme();
    let isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));

    if (isSmallerScreen) {
        return (
            <Chip
                label={<PeopleIcon sx={{ fill: '#fff' }} />}
                variant="outlined"
                size="small"
                sx={{
                    flex: '0 0 auto',
                    '.MuiChip-label': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }
                }}
            />
        );
    }

    return <ImpersonationChip label={label} variant="outlined" size="small" />;
}

export default ImpersonationLabel;
